import { unreadable } from './shared.ts';

/**
 * §8's Popular row and the trending section on it — revised now that the Trending *screen* is
 * retired. Two endpoints, one page, and the facts that differ.
 *
 * The `lede` for Popular is measured rather than assumed: that list has no overlap at all with
 * `/trending` (0 of 40), its view counts run from 371 to 240 264, and it is ordered newest-first. It is
 * the instance's own list, computed from what its users watch — not YouTube's chart, which is a
 * difference about *what the reader is looking at* and so belongs on the page.
 */
export const feed = {
  popular: {
    heading: 'Popular',
    lede: 'What people on this instance are watching, newest first. It is not a YouTube-wide chart.',
    emptyTitle: 'Nothing popular yet',
    emptyDetail:
      'Popular comes from what this instance\'s own visitors watch, so a quiet instance has an empty list. The Trending section above it comes from YouTube and does not depend on it.',
    noun: 'Popular',
    unreadableTitle: 'Could not read this list',
  },
  trending: {
    heading: 'Trending',
    lede: 'YouTube\'s trending list, for the content region set on this instance.',
    emptyTitle: 'Trending is empty',
    emptyDetail: 'Nothing came back, which usually means YouTube would not serve the list.',
    noun: 'Trending',
    unreadableTitle: 'Could not read this feed',
  },

  /** An answer arrived and not one video in it could be shown — an empty page for a different reason. */
  allDropped: 'The instance answered, and nothing in it could be shown.',

  problem: {
    notFoundTitle: (noun: string): string => `This instance has no ${noun}`,
    notFoundDetail: 'It is not served here. Some instances leave parts of the app out.',
    unreadableTitle: (noun: string): string => `Could not read ${noun}`,
    unreadable: unreadable(''),
    /** §8: "grey out Popular **with a reason** if the instance disabled it" — `popular_enabled: false`. */
    disabledTitle: (noun: string): string => `${noun} is switched off on this instance`,
    disabledDetail: 'Its administrator turned it off. Every other page works normally.',
  },

  /** The heading is a noun, so the sentence takes it rather than embedding a word order. */
  loading: (heading: string): string => `Loading ${heading}…`,
  region: (code: string): string => `Region ${code}.`,
} as const;
